import AWSAppSyncClient from 'aws-appsync';
import config from '../../aws-exports';
import Amplify, { Auth } from 'aws-amplify';
import { InMemoryCache } from 'apollo-cache-inmemory';

Amplify.configure(config);

const cache = new InMemoryCache();
export { config };
export function createClient(opts = {}) {
  return new AWSAppSyncClient(
    {
      url: config.aws_appsync_graphqlEndpoint,
      region: config.aws_appsync_region,
      auth: {
        type: config.aws_appsync_authenticationType,
        jwtToken: async () =>
          (await Auth.currentSession()).getAccessToken().getJwtToken(),
      },
      ...opts,
    },
    {
      cache,
      defaultOptions: {
        // watchQuery: { fetchPolicy: 'cache-and-network' },
      },
    },
  );
}

export const client = createClient();
